__turbopack_context__.v({
  "active": "Fa5q6G_active",
  "backgroundColor": "Fa5q6G_backgroundColor",
  "line": "Fa5q6G_line",
  "root": "Fa5q6G_root",
});
